export default __webpack_public_path__ + "static/media/GI.aca07b0c.svg";